<template>
  <!-- eslint-disable  -->
  <form class="px-3 mb-4 force-bind-modal" v-on:submit.prevent="submitForceBind" action="self">
    <hr />
    <label>Binding Carrier <span class="required-red">*</span></label>
    <div class="form-group">
      <div class="btn-group btn-group-toggle  w-auto smaller-font-content" data-toggle="buttons" tabindex="-1">
        <v-select class=" w-auto" :options="carriers"
          v-bind:class="{ 'std-width form-control': false, 'error': formErrors.carrier }" label="carrier_name"
          name="force-bind-carrier-select" id="force-bind-carrier-select" ref="forcebindcarrierselectref"
          v-model="selectedCarrier" size="auto" placeholder="Select One" />
      </div>
      <i v-bind:class="{ 'warning fas fa-exclamation-triangle': formErrors.carrier }"></i>
    </div>
    <div class="form-group">
      <label>Policy Number<span class="required-red">*</span></label>
      <div class="input-group w-50">
        <input type="text" v-bind:class="{ 'form-control': true, 'w-50': true, 'error': formErrors.policyNumber }"
          v-model="formFields.policyNumber">
        <i v-bind:class="{ 'warning fas fa-exclamation-triangle': formErrors.policyNumber }"></i>
      </div>
      <div class="field-subtext pr-2">
        <div class="form-text smaller-font-content">20 Character Maximum</div>
      </div>
    </div>
    <div class="form-group w-50">
      <label>Total Premium<span class="required-red">*</span></label>
      <div class="input-group">
        <money v-model="formFields.price" v-bind="money" maxlength="9"
          v-bind:class="{ 'form-control': true, 'error': formErrors.finalPremium }"></money>
        <i v-bind:class="{ 'warning fas fa-exclamation-triangle': formErrors.finalPremium }"></i>
      </div>
      <div class="field-subtext pr-2">
        <div class="form-text smaller-font-content">7 Digit Maximum ($XXXXX.XX)</div>
      </div>
    </div>
    <div class="form-group" v-if="productName === 'Auto'">
      <div><label>Policy Term<span class="required-red">*</span></label></div>
      <div class="input-group field-input-radio">
        <div data-toggle="buttons" class="btn-group btn-group-toggle" :class="{ 'error': formErrors.termLength }">
          <div class="btn btn-outline-light" :class="{ 'active': formFields.termLength === '12Month' ? true : false, }">
            <input name="radio-term-length" v-model="formFields.termLength" id="term-12-mo-radio" type="radio"
              value="12Month">
            <label class="cursorBox" for="term-12-mo-radio">12 months</label>
          </div>
          <div class="btn btn-outline-light" :class="{ 'active': formFields.termLength === '6Month' ? true : false, }">
            <input name="radio-term-length" v-model="formFields.termLength" id="term-6-mo-radio" type="radio"
              value="6Month">
            <label class="cursorBox" for="term-6-mo-radio">6 months</label>
          </div>
        </div>
        <i v-bind:class="{ 'warning fas fa-exclamation-triangle': formErrors.termLength }"></i>
      </div>
    </div>
    <div class="form-group">
      <label>Policy Effective Date<span class="required-red">*</span></label>
      <div class="input-group">
        <datepicker v-model="formFields.date" :bootstrap-styling="true" :typeable="true" format="MM/dd/yyyy"
          placeholder="MM/DD/YYYY" style="width:6rem;" :input-class="{ 'error': formErrors.effectiveDate }"
          @opened="clearDateErrors()"></datepicker>
        <i v-bind:class="{ 'warning fas fa-exclamation-triangle': formErrors.effectiveDate }"></i>
      </div>
    </div>
    <hr />
    <!-- CONFIRM & CONSENT NOTICE -->
    <div class="d-block justify-content-center mx-auto my-3">
      <div class="alert alert-warning mx-3 my-0 py-2" role="alert">
        <div class="row no-gutters">
          <div class="d-inline-block pr-2 my-auto">
            <img width="25px" height="25px" src="../../assets/exclamation-circle-yellow-new.svg" alt="info">
          </div>
          <div class="col smaller-font-content d-inline-block my-auto">
            <p class="mb-0">Advise the customer of the next steps including that they must sign the application to
              avoid a premium increase or cancellation.</p>
          </div>
        </div>
      </div>
    </div>
    <!-- CONFIRM & CONSENT NOTICE -->
    <button type="submit" v-if="namedInsuredStatus()" id="force-bind-submit-button"
      class="btn btn-primary d-block mx-auto">Force Bind Policy</button>
  </form>
</template>

<script>
/* eslint-disable */
import vSelect from 'vue-select';
import Datepicker from 'vuejs-datepicker';
import postData from '../../services/postData';

export default {
  props: ['carriers', 'namedInsuredStatus', 'productName'],
  data() {
    return {
      selectedCarrier: '',
      formErrors: {
        general: '',
        carrier: '',
        policyNumber: '',
        finalPremium: '',
        effectiveDate: '',
        termLength: '',
      },
      formFields: {
        carrier: '',
        policyNumber: '',
        price: '',
        termLength: '',
        date: '',
      },
      money: {
        decimal: '.',
        thousands: ',',
        precision: 2,
      },

    };
  },
  components: {
    vSelect,
    Datepicker,
  },
  methods: {
    checkForceBindForm() {
      if (this.productName === 'Auto' && this.selectedCarrier.carrier_id && this.formFields.policyNumber && this.formFields.price && this.formFields.date && this.formFields.termLength) {
        return true;
      }
      if (this.productName !== 'Auto' && this.selectedCarrier.carrier_id && this.formFields.policyNumber && this.formFields.price && this.formFields.date) {
        return true;
      }
      if (!this.selectedCarrier.carrier_id) {
        this.formErrors.carrier = 'Please select Carrier';
      }
      if (!this.formFields.policyNumber) {
        this.formErrors.policyNumber = 'Please enter Policy Number';
      }
      if (!this.formFields.price) {
        this.formErrors.finalPremium = 'Please enter Final Premium';
      }
      if (this.productName === 'Auto' && !this.formFields.termLength) {
        this.formErrors.termLength = 'Please select a Term Length';
      }
      if (!this.formFields.date) {
        this.formErrors.effectiveDate = 'Please enter Date';
      }
      return false;
    },
    submitForceBind() {
      this.formErrors = {};

      if (this.checkForceBindForm()) {
        const forceBindSubmitButton = document.getElementById('force-bind-submit-button');
        forceBindSubmitButton.disabled = true;
        this.formFields.carrier = this.selectedCarrier.carrier_id;
        const finalDate = this.getFinalDate();
        const requestBody = {
          SessionId: this.$store.getters.getSessionID,
          CarrierId: this.formFields.carrier,
          PolicyNumber: this.formFields.policyNumber,
          Premium: this.formFields.price.toString(),
          Term: this.formFields.termLength,
          PolicyEffectiveDate: finalDate,
        };
        const url = '/autoquotes/forcebind';
        postData.submitForceBind(url, requestBody).then((response) => {
          if (response.status === 200 && response.statusText === 'OK') {
            this.$router.push({
              name: 'search',
              params: {
                forceBindData: 'make it truthy!'
              }
            });
            this.$store.dispatch('setForceBindSuccessful');
            forceBindSubmitButton.disabled = false;
          }
        }).catch((error) => {
          this.formErrors.general = error.response.data.Message;
          forceBindSubmitButton.disabled = false;
        });
      }
    },
    getFinalDate() {
      const year = this.formFields.date.getFullYear();
      // make sure that month and date are prepended with 0 if a single digit number
      const month = `0${this.formFields.date.getMonth() + 1}`.slice(-2);
      const day = `0${this.formFields.date.getDate()}`.slice(-2);
      return `${year}${month}${day}`;
    },
  },
  watch: {
    selectedCarrier: function () {
      this.formErrors.carrier = '';
    },
    'formFields.policyNumber': function () {
      this.formErrors.policyNumber = '';
    },
    'formFields.termLength': function () {
      this.formErrors.termLength = '';
    },
    'formFields.price': function () {
      this.formErrors.finalPremium = '';
    },
  },
}

</script>
<style lang="scss">
.force-bind-modal {
  .required-red {
    color: #FF4400;
  }

  .w-auto {
    width: auto !important;
  }

  label {
    display: inline-block;
    margin-bottom: 0.125rem;
    font-size: 0.75rem;
    line-height: 1.25rem;
    font-weight: 600;
  }

  .btn-group.btn-group-toggle .btn {
    padding: 0.1875rem 1.5rem 0;
  }

  .btn-outline-light {
    color: #333333;
    background-color: transparent;
    background-image: none;
    border-color: #ced4da;
  }

  .btn-outline-light:not(:disabled):not(.disabled):active,
  .btn-outline-light:not(:disabled):not(.disabled).active,
  .show>.btn-outline-light.dropdown-toggle {
    color: #FFFFFF;
    background-color: #003366;
    border-color: #003366;
  }

  .btn-group-toggle>.btn input[type=radio],
  .btn-group-toggle>.btn input[type=checkbox],
  .btn-group-toggle>.btn-group>.btn input[type=radio],
  .btn-group-toggle>.btn-group>.btn input[type=checkbox] {
    position: absolute;
    clip: rect(0, 0, 0, 0);
    pointer-events: none;
  }

  input[type=radio],
  input[type=checkbox] {
    box-sizing: border-box;
    padding: 0;
  }

  .form-group {
    .text-danger {
      color: #BB0000 !important;
      background-color: transparent !important;
      padding: 0;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/shared/MonolineForceBindModal.vue?054a44f0